import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    .tooltip-graph-content{
      position: relative;
      padding: 16px;
      .custom-tooltip-content-inner {
        position: absolute;
        background-color: var(--gray-0);
        color: var(--gray-800);
        padding: 10px;
        width: 130px;
        height: 60px;
        box-shadow: 0px 1px 4px 0px #00000033;
        right: 0;
        left: -50px;
        bottom: -8px;
        margin-left: auto;
        margin-right: auto;
        z-index: 999999;
        div, span {
          color: #364159;
        }
        div {
          font-weight: 600;
          padding-bottom: 5px;
        }
        span {
          padding-top: 5px;
          font-weight: normal;
        }
      }
    }

    .tooltip-graph-content ~ .intelie-ui-tooltip-arrow{
      background-color: white;  
      left: 20px;
      bottom: -4px;
      z-index: 10000;
    }
`
